var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBuilding, faDownload, faEdit, faPlay, faSpinner, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {} from "axios";
import { BAlert, BButton, BCard } from "bootstrap-vue";
import { computed, onMounted, ref, watch } from "vue";
import {} from "@/api/workflows";
import { fromSimple } from "@/components/Workflow/Editor/modules/model";
import { getWorkflowFull, getWorkflowInfo } from "@/components/Workflow/workflows.services";
import { useDatatypesMapper } from "@/composables/datatypesMapper";
import { provideScopedWorkflowStores } from "@/composables/workflowStores";
import { useUserStore } from "@/stores/userStore";
import { assertDefined } from "@/utils/assertions";
import { withPrefix } from "@/utils/redirect";
import ActivityBar from "@/components/ActivityBar/ActivityBar.vue";
import Heading from "@/components/Common/Heading.vue";
import WorkflowGraph from "@/components/Workflow/Editor/WorkflowGraph.vue";
import WorkflowInformation from "@/components/Workflow/Published/WorkflowInformation.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowPublished',
    props: {
        id: null,
        zoom: { default: 0.75 },
        embed: { type: Boolean, default: false },
        initialX: { default: -20 },
        initialY: { default: -20 },
        quickView: { type: Boolean, default: false },
        showAbout: { type: Boolean, default: true },
        showHeading: { type: Boolean, default: true },
        showMinimap: { type: Boolean, default: true },
        showButtons: { type: Boolean, default: true },
        showZoomControls: { type: Boolean, default: true }
    },
    setup(__props) {
        const props = __props;
        library.add(faBuilding, faDownload, faEdit, faPlay, faSpinner, faUser);
        const userStore = useUserStore();
        const { datatypesMapper } = useDatatypesMapper();
        const { stateStore } = provideScopedWorkflowStores(props.id);
        const loading = ref(true);
        const errorMessage = ref("");
        const workflowInfo = ref();
        const workflow = ref(null);
        const hasError = computed(() => !!errorMessage.value);
        const downloadUrl = computed(() => withPrefix(`/api/workflows/${props.id}/download?format=json-download`));
        const importUrl = computed(() => withPrefix(`/workflow/imp?id=${props.id}`));
        const runUrl = computed(() => withPrefix(`/workflows/run?id=${props.id}`));
        const initialPosition = computed(() => ({
            x: -props.initialX * props.zoom,
            y: -props.initialY * props.zoom,
        }));
        const viewUrl = computed(() => withPrefix(`/published/workflow?id=${props.id}`));
        const sharedWorkflow = computed(() => {
            var _a;
            return !userStore.matchesCurrentUsername((_a = workflowInfo.value) === null || _a === void 0 ? void 0 : _a.owner);
        });
        const editButtonTitle = computed(() => {
            var _a;
            if (userStore.isAnonymous) {
                return "Log in to edit Workflow";
            }
            else {
                if ((_a = workflowInfo.value) === null || _a === void 0 ? void 0 : _a.deleted) {
                    return "You cannot edit a deleted workflow. Restore it first.";
                }
                else {
                    return "Edit Workflow";
                }
            }
        });
        function logInTitle(title) {
            if (userStore.isAnonymous) {
                return `Log in to ${title}`;
            }
            else {
                return title;
            }
        }
        function load() {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                errorMessage.value = "";
                try {
                    const [workflowInfoData, fullWorkflow] = yield Promise.all([
                        getWorkflowInfo(props.id),
                        getWorkflowFull(props.id),
                    ]);
                    assertDefined(workflowInfoData.name);
                    workflowInfo.value = workflowInfoData;
                    workflow.value = fullWorkflow;
                    fromSimple(props.id, fullWorkflow);
                }
                catch (e) {
                    const error = e;
                    if ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data.err_msg) {
                        errorMessage.value = (_b = error.response.data.err_msg) !== null && _b !== void 0 ? _b : "Unknown Error";
                    }
                }
                finally {
                    loading.value = false;
                }
            });
        }
        watch(() => props.zoom, () => (stateStore.scale = props.zoom), { immediate: true });
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            yield load();
        }));
        return { __sfc: true, props, userStore, datatypesMapper, stateStore, loading, errorMessage, workflowInfo, workflow, hasError, downloadUrl, importUrl, runUrl, initialPosition, viewUrl, sharedWorkflow, editButtonTitle, logInTitle, load, faDownload, faEdit, faPlay, faSpinner, FontAwesomeIcon, BAlert, BButton, BCard, ActivityBar, Heading, WorkflowGraph, WorkflowInformation };
    }
});
